// B2BES [AST-426] - ADD Customization - Ensure if ACH is chosen that a valid ACH account is selected. Part of AST-359 EVO Payments
import { addToChainAfter } from "@insite/client-framework/HandlerCreator"; import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import placeOrder, { PopulateApiParameter } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { chain } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

// Within the handler itself. Has more properties than the parameter passed into the handler from outside.
export type HandlerType = Parameters<typeof PopulateApiParameter>[0];

// Passed in to the handler from outside.
export type ACHAccountHandlerType = Parameters<typeof placeOrder>[0] & {
    achAccountId: string;
    jobName: string;
};

export const PopulateCustomApiParameters = (props: HandlerType) => {
    if (!props.cartToUpdate) {
        return;
    }

    props.cartToUpdate.properties["auersteel_achAccountId"] = (props.parameter as ACHAccountHandlerType).achAccountId;
    props.cartToUpdate.properties["auersteel_jobName"] = (props.parameter as ACHAccountHandlerType).jobName;
}

addToChainAfter(chain, PopulateApiParameter, PopulateCustomApiParameters);